module.exports = "<ng-progress [minimum]=\"0.05\" [maximum]=\"1\"\n             [speed]=\"800\" [showSpinner]=\"true\"\n             [color]=\"'green'\" [trickleSpeed]=\"300\" [thick]=\"true\" [ease]=\"'linear'\"\n></ng-progress>\n<router-outlet ></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main